import { Toast } from 'buefy/dist/components/toast'

export default function log (type = 'dark', text) {
  Toast.open({
    message: text,
    type: `is-${type}`,
    position: 'is-top-right',
    duration: 4000
  })
}
